import generateSnippetId from './generate-snippet-id';

const addIdsToCustomCodeSnippets = (snippets) =>
  snippets.map((snippet) => ({
    ...snippet,
    id: snippet.id || generateSnippetId(),
  }));

export default addIdsToCustomCodeSnippets;
